import { Component } from '@angular/core';
import {  Router } from '@angular/router';
import { ChartConfiguration, ChartData, ChartEvent, ChartType } from 'chart.js';

@Component({
  selector: 'app-statistiche-progetto',
  templateUrl: './statistiche-progetto.component.html',
  styleUrls: ['./statistiche-progetto.component.css']
})
export class StatisticheProgettoComponent {
  public pieChartLabels: string[] = ['Percentuale 1', 'Percentuale 2', 'Percentuale 3'];
  public pieChartData: number[] = [30, 40, 30]; // Inserisci qui le tue percentuali
  public pieChartType: string = 'pie';

  sprints = [
    { value: 1 },
    { value: 2 },
  ];

  percentage = [
    { value: 50 },
    { value: 60 },
  ];

  public barChartOptions: ChartConfiguration['options'] = {
    elements: {
      line: {
        tension: 0.4,
      },
    },
    // We use these empty structures as placeholders for dynamic theming.
    scales: {
      x: {},
      y: {
        min: 10,
      },
    },
    plugins: {
      legend: { display: true },
    },
  };

  switchIndex = 0;

  public barChartLabels: string[] = [
    '2006',
    '2007',
    '2008',
    '2009',
    '2010',
    '2011',
    '2012',
  ];
  public barChartType: ChartType = 'bar';

  public barChartData: ChartData<'bar'> = {
    labels: this.barChartLabels,
    datasets: [
      { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
      { data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B' },
    ],
  };

    // events
    public chartClicked({
      event,
      active,
    }: {
      event?: ChartEvent;
      active?: object[];
    }): void {
    }

    public chartHovered({
      event,
      active,
    }: {
      event?: ChartEvent;
      active?: object[];
    }): void {
    }


    isPanelOpen: boolean = false;
  constructor(public router:Router) {}


  goToScrum(){
    this.router.navigate(['/secure/dashboard/i-miei-team/sprints']);
  }

  stopEventPropagation(event: Event) {
    event.stopPropagation();
  }
}
